module.exports = __webpack_public_path__ + "img/ETH.cb8c15bf.svg";